module.exports = __webpack_public_path__ + "img/202509-2_10.2b0643f3.jpg";